<template>
  <Component
    :is="overlay"
    v-if="overlay"
    :key="resourceId"
    :resource-id="resourceId"
    @closed="closeOverlay(currentTab.value)"
  />
</template>

<script setup lang="ts">
import { useHead } from '@unhead/vue';
import type { Component } from 'vue';
import { computed, onMounted } from 'vue';
import { useRoute } from 'vue-router';

import type { ApiTabValueType } from '../types';
import useApiRoutes from '../useApiRoutes';
import useApiTabs from '../useApiTabs';

import ApiFilterDrawer from './ApiFilterDrawer.vue';
import ApiWebhookSettingsDrawer from './ApiWebhookSettingsDrawer.vue';

const DETAIL_COMPONENTS: Partial<Record<ApiTabValueType, Component>> = {
  webhooks: ApiWebhookSettingsDrawer,
  filters: ApiFilterDrawer,
};

const route = useRoute();
const { getTabByValue } = useApiTabs();
const { closeOverlay } = useApiRoutes();

const currentTab = computed(() => getTabByValue(route.params.tab as string));
const resourceId = computed(() => route.params.id as string);
const overlay = computed(() => DETAIL_COMPONENTS[currentTab.value.value]);

onMounted(() => {
  if (!overlay.value) closeOverlay(currentTab.value.value);
});

useHead({
  title: computed(() => `${currentTab.value.name} - API - Crossbeam`),
});
</script>
